export default [
  {
    path: '/roles',
    name: 'roles',
    component: () => import('@/views/modules/skeleton/admin/Roles/Roles.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Roles',
          active: true,
          // back: true
        },
      ],
    },
  },
  {
    path: '/permissions/:id',
    name: 'permissions',
    component: () => import('@/views/modules/skeleton/admin/Roles/Permissions'),
    meta: {
      breadcrumb: [
        {
          text: 'Roles',
          back: true,
          to: '/roles',
        },

      ],
    },
  },
  {
    path: '/add_role',
    name: 'add_role',
    component: () => import('@/views/modules/skeleton/admin/Roles/addRole.vue'), // alter component name
    meta: {
      breadcrumb: [
        {
          text: 'Add Role',
          active: true,
          back: true,
        },
      ],
    },
  },
  {
    path: '/AssignRole/:id',
    name: 'assign_role',
    component: () => import('@/views/modules/skeleton/admin/Roles/AssignRole'),
    meta: {
      breadcrumb: [
        {
          text: 'Edit Roles',
          back: true,
          active: true,
          redirectIfLoggedIn: true,
        },
      ],
    },
  },
]
